import { IResultData } from "@/domain/entities/shared/result";
import { useLineStore } from "@/stores/lineStore";
import { ref } from "vue";

interface IRemoveFavoriteLineParams {
  onSuccess?: (result: IResultData<boolean>, busStopId: string) => void;
  onError?: (result: IResultData<boolean>) => void;
}

export const useRemoveFavoriteBusStop = ({
  onSuccess,
  onError,
}: IRemoveFavoriteLineParams) => {
  const lineStore = useLineStore();
  const data = ref(false);

  const removeFavoriteBusStop = async (busStopId: string) => {
    const result = await lineStore.removeFavoriteBusStop(busStopId);

    result.isSuccess
      ? onSuccess && onSuccess(result, busStopId)
      : onError && onError(result);
  };

  return {
    data,
    removeFavoriteBusStop,
  };
};
